import { render, staticRenderFns } from "./ReportingData.vue?vue&type=template&id=50ac3209"
import script from "./ReportingData.vue?vue&type=script&lang=js"
export * from "./ReportingData.vue?vue&type=script&lang=js"
import style0 from "./ReportingData.vue?vue&type=style&index=0&id=50ac3209&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports